export const itineraryKeys = {
	all: (circleId: string) => ['itinerary', circleId],
	list: (circleId: string) => [...itineraryKeys.all(circleId), 'list'],
	add: () => ['itinerary', 'add'],
	delete: () => ['itinerary', 'delete'],
	update: () => ['itinerary', 'update'],
	detail: (itineraryId: string) => ['itinerary', itineraryId],
};
